export const initDemoPopup = () => {
    const popup = document.querySelector('[data-demo-popup]');
    if (!popup || popup.dataset.initialized) return;
    const panel = popup.querySelector('.demo-popup__panel');
    const form = popup.querySelector('form');
    if (!panel || !form) return;
    popup.dataset.initialized = 'true';

    const html = document.documentElement;
    const closeButton = popup.querySelector('[data-demo-popup-close]');
    const phone = form.querySelector('.js-phone-mask');
    const triggerSelector = '[data-demo-popup-open], a[href="#demo-request"], a[href="#request-demo"]';
    const focusSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let opener = null;
    let scrollPosition = 0;
    let countryDropdownOpen = false;
    let closing = false;
    let closeTimer = null;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const finishClose = () => {
        if (!closing) return;
        clearTimeout(closeTimer);
        closing = false;
        popup.hidden = true;
        html.classList.remove('demo-popup-open');
        html.style.removeProperty('--demo-popup-scroll-top');
        html.style.removeProperty('--demo-popup-scrollbar-width');
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    };

    const close = () => {
        if (popup.hidden || closing) return;
        if (countryDropdownOpen) {
            document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
        }
        closing = true;
        popup.classList.remove('demo-popup--from-trigger');
        popup.classList.remove('is-open');
        if (reducedMotion.matches) finishClose();
        else closeTimer = setTimeout(finishClose, 300);
    };

    popup.addEventListener('transitionend', (event) => {
        if (event.target !== popup || event.propertyName !== 'opacity') return;
        if (closing) finishClose();
        else popup.classList.remove('demo-popup--from-trigger');
    });

    const prepareOrigin = (point, triggerRect) => {
        // Measure the final layout without the default entrance transform.
        panel.style.transition = 'none';
        panel.style.transform = 'none';
        const rect = panel.getBoundingClientRect();
        const scale = Math.min(0.28, Math.max(0.12, triggerRect.width / rect.width));
        popup.style.setProperty('--popup-origin-x', (point.x - rect.x - rect.width / 2) + 'px');
        popup.style.setProperty('--popup-origin-y', (point.y - rect.y - rect.height / 2) + 'px');
        popup.style.setProperty('--popup-origin-scale', scale);
        popup.classList.add('demo-popup--from-trigger');
        panel.style.removeProperty('transform');
        // Commit the starting pose before restoring transitions.
        void panel.offsetWidth;
        panel.style.removeProperty('transition');
    };

    const open = (trigger, event) => {
        if (closing) {
            clearTimeout(closeTimer);
            closing = false;
            popup.classList.add('is-open');
            closeButton.focus({ preventScroll: true });
            return;
        }
        if (!popup.hidden) return;
        opener = trigger;
        const triggerRect = trigger.getBoundingClientRect();
        const point = event.detail > 0
            ? { x: event.clientX, y: event.clientY }
            : { x: triggerRect.x + triggerRect.width / 2, y: triggerRect.y + triggerRect.height / 2 };
        scrollPosition = window.scrollY;
        const scrollbarWidth = Math.max(0, window.innerWidth - html.clientWidth);
        html.style.setProperty('--demo-popup-scrollbar-width', scrollbarWidth + 'px');
        html.style.setProperty('--demo-popup-scroll-top', '-' + scrollPosition + 'px');
        html.classList.add('demo-popup-open');
        popup.hidden = false;
        if (!reducedMotion.matches) prepareOrigin(point, triggerRect);
        // Commit the initial opacity/offset before starting the transition.
        void popup.offsetWidth;
        popup.classList.add('is-open');

        // Preserve the existing per-button HubSpot redirect contract.
        const redirect = trigger.getAttribute('data-redirect-to-hubspot');
        const previousRedirect = form.querySelector('[name="hubspotRedirectLink"]');
        if (previousRedirect) previousRedirect.remove();
        form.removeAttribute('data-redirect-to-hubspot');
        if (redirect) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'hubspotRedirectLink';
            input.value = redirect;
            form.appendChild(input);
            form.setAttribute('data-redirect-to-hubspot', redirect);
        }

        closeButton.focus({ preventScroll: true });
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest(triggerSelector);
        if (trigger) {
            event.preventDefault();
            open(trigger, event);
        }
    });

    closeButton.addEventListener('click', close);
    let backdropPressed = false;
    popup.addEventListener('pointerdown', (event) => {
        backdropPressed = event.target === popup;
    });
    popup.addEventListener('click', (event) => {
        if (event.target === popup && backdropPressed) close();
        backdropPressed = false;
    });

    if (phone) {
        phone.addEventListener('open:countrydropdown', () => {
            countryDropdownOpen = true;
        });
        phone.addEventListener('close:countrydropdown', () => {
            countryDropdownOpen = false;
        });
    }

    // The phone widget focuses its body-level portal before emitting its open event.
    const countryPortal = () => document.querySelector('.iti--container');

    document.addEventListener('keydown', (event) => {
        if (popup.hidden) return;
        // The telephone widget handles Escape and keyboard navigation first.
        if (countryDropdownOpen && event.key !== 'Tab') return;
        if (event.key === 'Escape') {
            event.preventDefault();
            close();
        }
        if (event.key !== 'Tab') return;
        const focusRoot = countryPortal() || panel;
        const focusable = Array.from(focusRoot.querySelectorAll(focusSelector))
            .filter((element) => element.getClientRects().length && element.tabIndex >= 0);
        const first = focusable[0] || panel;
        const last = focusable[focusable.length - 1] || panel;
        const active = document.activeElement;
        if (event.shiftKey && (active === first || active === panel)) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && (active === last || !focusRoot.contains(active))) {
            event.preventDefault();
            first.focus();
        }
    }, true);

    document.addEventListener('focusin', (event) => {
        if (popup.hidden || panel.contains(event.target)) return;
        const portal = countryPortal();
        if (portal && portal.contains(event.target)) return;
        closeButton.focus({ preventScroll: true });
    });
};
